import { Box, CardContent, Typography } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PropTypes from 'prop-types';
import { StyledSalseCard, StypedIconBox } from '../ThemeComponent';

interface SalesCardProps {
	title?: string;
	amount?: string;
	description?: string;
	icon?: React.ReactNode;
	cardColor: string;
	textColor: string;
}

const SalesCard: React.FC<SalesCardProps> = ({
	title = 'Total Sales',
	amount = '0',
	description = 'Monthly revenue',
	cardColor = '#ECF5F5',
	icon = <AttachMoneyIcon style={{ color: 'green' }} />,
	textColor = '#ECF5F5',
}) => {
	console.log('totalRevenue');

	return (
		<StyledSalseCard sx={{ backgroundColor: `${cardColor}`, border: '0px' }}>
			<CardContent style={{ padding: '16px', width: '100%' }}>
				<Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
					<Typography variant="h6" component="div">
						{title}
					</Typography>
					<StypedIconBox
						style={{ backgroundColor: '#F9F9F9', padding: '8px', borderRadius: '4px' }}
					>
						{icon}
					</StypedIconBox>
				</Box>
				<Typography variant="h4" sx={{ color: `${textColor}` }}>
					{title === 'Total Revenue' ? '₹' : null} {amount}
				</Typography>
				<Typography variant="body2" sx={{ color: '#555555' }}>
					{description}
				</Typography>
			</CardContent>
		</StyledSalseCard>
	);
};

SalesCard.propTypes = {
	title: PropTypes.string,
	amount: PropTypes.string,
	description: PropTypes.string,
	icon: PropTypes.node,
	cardColor: PropTypes.string,
	textColor: PropTypes.string,
};

export default SalesCard;
